import { Checkbox, Form, Input, InputNumber, Modal, Select } from 'antd';
import { useChangeHandler } from 'hooks';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { screensCleanUp } from 'state/actions/screens';
import { regexDescription, regexInput } from 'utils/regex';
import { log } from 'utils';
import { Option } from 'antd/lib/mentions';
import _ from 'underscore';

export default function ModalScreenForm({
  screen,
  setScreen,
  visible,
  onCancel,
  onCreate,
  isEditing,
}) {
  const dispatch = useDispatch();
  const { siteId } = useParams();

  const [form] = Form.useForm();

  const { loading,screenGroupList, mediaCategoryList } = useSelector(
    (state) => ({
      loading: state.sites.loading,
      screenGroupList: state.screengroup.list,
      mediaCategoryList: state.mediaCategories.list,
    }),
    shallowEqual
  );

  const [errors, setErrors] = useState({
    name: '',
    description: '',
  });


  useEffect(() => {
    return () => dispatch(screensCleanUp());
  }, [dispatch]);

  const onChangeHandler = useChangeHandler(setScreen);

  const onChangeResolution = (field, value) => {
    // Remove non-numeric characters (allowing only numbers)
    const cleanedValue = value ? String(value).replace(/\D/g, '') : '';
    setScreen((prev) => ({ ...prev, [field]: cleanedValue ? Number(cleanedValue) : null }));
  };

  const onSave = (values) => {
    if (
      (!regexInput(values.name) && values.name) ||
      (!regexDescription(values.description) && values.description)
    ) {
      setErrors({
        ...errors,
        name:
          !regexInput(values.name) &&
          values.name &&
          'This field cannot contain a special characters',
        description:
          !regexDescription(values.description) &&
          values.description &&
          'This field cannot contain a special characters',
      });
    } else {
      setErrors({
        name: '',
        description: '',
      });
      onCreate({
        ...screen,
        id: screen._id,
        name: values.name,
        adsumScreenId: values.adsumScreenId,
        siteId,
        description: values.description,
        isLive: values.isLive,
      });
      form.resetFields();
    }
  };
  const onChangeSelect = (keyString, value) => {
    setScreen((prevState) => ({
      ...prevState,
      [keyString]: value,
    }));
  };

  return (
    <Modal
      visible={visible}
      centered
      title={isEditing ? 'Edit Screen' : 'Create New Screen'}
      okText="Submit"
      confirmLoading={loading}
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onSave(values);
          })
          .catch((info) => {
            log('Validate Failed:', info);
          });
      }}
    >
      <Form
        layout="vertical"
        form={form}
        onChange={onChangeHandler}
        initialValues={{
          name: screen.name,
          description: screen.description,
          adsumScreenId: screen.adsumScreenId,
          height: screen.height,
          width: screen.width,
          groupId: screen.groupId,
          isLive: screen.isLive,
          mediaCategoryId: screen.mediaCategoryId,
        }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true }]}
          validateStatus={errors.name ? 'error' : 'success'}
          help={errors.name ? errors.name : null}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Adsum/Editor Screen Id"
          name="adsumScreenId"
          rules={[]}
          validateStatus={errors.name ? 'error' : 'success'}
          help={errors.name ? errors.name : null}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Screen Group"
          name="groupId"
          validateStatus={errors.groupId ? 'error' : 'success'}
          help={errors.groupId ? errors.groupId : null}
        >
          <Select
            placeholder="Select Access"
            value={screen.groupId}
            onChange={(value)=>onChangeSelect('groupId', value)}
            // disabled={userData && userData.role === 'admin'}
          >
            {screenGroupList.map((group) => (
              <Option key={group._id} value={group._id}>
                {group.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Media Categories"
          name="mediaCategoryId"
          validateStatus={errors.mediaCategoryId ? 'error' : 'success'}
          help={errors.mediaCategoryId ? errors.mediaCategoryId : null}
        >
          <Select
            placeholder="Select Media Categories"
            value={screen.mediaCategoryId}
            onChange={(value)=>onChangeSelect('mediaCategoryId', value)}
            // disabled={userData && userData.role === 'admin'}
          >
            {_.sortBy(mediaCategoryList, 'name').map((group) => (
              <Option key={group._id} value={group._id}>
                {group.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Screen Width"
          name="width"
          rules={[
            { type: 'number', min: 10, message: 'Width must be at least 100' },
          ]}
          validateStatus={errors.width ? 'error' : 'success'}
          help={errors.width ? errors.width : null}
        >
          <InputNumber name="width" value={screen.width} onChange={(value) => onChangeResolution('width', value)}

          />
        </Form.Item>
        <Form.Item
          label="Screen Height"
          name="height"
          rules={[
            { type: 'number', min: 100, message: 'Width must be at least 100' },
          ]}
          validateStatus={errors.height ? 'error' : 'success'}
          help={errors.height ? errors.height : null}
        >
          <InputNumber name="height" value={screen.height}
                       onChange={(value) => onChangeResolution('height', value)}
          />
        </Form.Item>
        <Form.Item
          label="Description"
          name="description"
          validateStatus={errors.description ? 'error' : 'success'}
          help={errors.description ? errors.description : null}
        >
          <Input.TextArea rows={4} placeholder="Description" />
        </Form.Item>
        <Form.Item name="isLive" valuePropName="checked">
          <Checkbox>Screen is Live on Site</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
}

ModalScreenForm.propTypes = {
  userData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
  }),
};
